import type { Bundle } from '@schibsted/frapi-schema';
import type {
  FrapiTeaserItem,
  FrontElement,
  TeaserWithChunk,
} from '../../../types/frapi-types.js';

const takeupRow = (
  el: Bundle<FrapiTeaserItem> | FrapiTeaserItem | FrontElement,
): boolean =>
  (el.type === 'teaser' && el.fullWidthTeaser) || el.type === 'bundle';

export function splitToChunks(
  items: (Bundle<FrapiTeaserItem> | FrapiTeaserItem)[],
) {
  const chunks: FrontElement[] = [];

  // group consecutive teasers into row-sized chunks; full-width teasers and
  // bundles each take their own row
  for (const el of items) {
    if (takeupRow(el)) {
      chunks.push(el);
      continue;
    }

    const last = chunks[chunks.length - 1];
    if (
      last?.type === 'chunk' &&
      last.items.length < pickChunkSize(chunks.length)
    ) {
      last.items.push(el as FrapiTeaserItem);
    } else {
      chunks.push(makeNewChunk(el as FrapiTeaserItem));
    }
  }

  // fill any single-teaser chunk by borrowing one teaser from a later chunk,
  // without emptying the donor or stranding a new single
  let pendingSingle: TeaserWithChunk | null = null;
  for (const curr of chunks) {
    if (curr.type !== 'chunk') {
      continue;
    }

    if (pendingSingle && curr.items.length > 1) {
      pendingSingle.items.push(curr.items.shift() as FrapiTeaserItem);
      pendingSingle = null;
    }

    pendingSingle = curr.items.length === 1 ? curr : null;
  }

  return chunks;
}

const makeNewChunk = (element: FrapiTeaserItem): FrontElement => {
  return { ...element, type: 'chunk', items: [element] };
};

const chunkSizes = [2, 3, 5, 2, 4, 3, 2, 3, 5, 4, 3, 4, 2, 3, 4];

const pickChunkSize = (currentRow: number): number => {
  return chunkSizes[currentRow];
};
